function mhfiltr() {
    if($('.desktop.filters-visible').length){
        $('.filters-unveil-button-wrapper a').attr('data-text', 'Otevřít filtr').text('Zavřít filtr')
        $('.filters').addClass('visible')
    }
    if($('.desktop.filter-label.active').length){
        $('body').addClass('filters-visible')
        $('.filters-unveil-button-wrapper a').attr('data-text', 'Otevřít filtr').text('Zavřít filtr')
        $('.filters').addClass('visible')
    }
    $(".breadcrumbs-wrapper .breadcrumbs").clone().prependTo("main#content");
    $('.slider-wrapper').addClass('filter-section')
    $('.filter-section:not(.slider-wrapper)').addClass('open-it')
    if($('.vybrane-filtry').length == 0) { 
        $('<div class="vybrane-filtry"</div>').insertAfter(".filters-wrapper"); 
    }
    $('.vybrane-filtry').html('')

    $(".filter-label.active").clone().appendTo(".vybrane-filtry");
    $(".vybrane-filtry .filter-label.active").closest("div").addClass("aktivni-filtr"); 
    $(".vybrane-filtry .filter-section fieldset div:not(.aktivni-filtr)").remove(); 
}
function psFilter() {
    if($('.mobile ').length){
        $('.filters').removeClass('visible')
        $('#category-filter-hover').removeClass('visible')
        $('body').removeClass('filters-visible')
        $('body:not(.filters-visible) .filters-unveil-button-wrapper a').attr('data-text', 'Otevřít filtr').text('Otevřít filtr')
    }
}

$(document).on('click', '.filter-section h4', function(){
    $(this).closest('.filter-section').toggleClass('open-it')
})

$(document).ready(function() { 
    mhfiltr(); 
    psFilter();
});  



document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhfiltr(); 
    if($('.mobile.filters-visible .filter-label.active').length == 0){
       
        $('.filters').removeClass('visible')
        $('#category-filter-hover').removeClass('visible')
        $('body').removeClass('filters-visible')
    }
});
document.addEventListener('ShoptetPagePriceFilterChange', function() {
    mhfiltr();
    if($('.mobile.filters-visible .filter-label.active').length == 0){
        $('#filters').addClass('visible')
        $('.filters-unveil-button-wrapper a').addClass('close-filter').attr('data-text', 'Otevřít filtr').text('Zavřít filtr')
    }
}); 

document.addEventListener('ShoptetPageFilterValueChange', function() {
    mhfiltr();
    if($('.mobile.filters-visible .filter-label.active').length == 0){
        $('#filters').addClass('visible')
        $('.filters-unveil-button-wrapper a').addClass('close-filter').attr('data-text', 'Otevřít filtr').text('Zavřít filtr')
    }
}); 

document.addEventListener('ShoptetPageFiltersCleared', function() {
    mhfiltr();
    if($('.mobile.filters-visible .filter-label.active').length == 0){
        $('#filters').addClass('visible')
        $('.filters-unveil-button-wrapper a').addClass('close-filter').attr('data-text', 'Otevřít filtr').text('Zavřít filtr')
    }
}); 